import { createContext, useContext, useState, useEffect } from 'react';
import {isNil, isEmpty} from 'ramda'

const tcDataContext = createContext();

const dataIsValid = (data) => {
  return !isNil(data) && !isEmpty(data)
}

export const TCDataProvider = ({ children }) => {
    const [tcData, setTCData] = useState(null)
    const [tcDataLoading, setTCDataLoading] = useState(false)
    const [tcDataError, setTCDataError] = useState(false)
    const [activeTCDataSet, setActiveTCDataSet] = useState(null)
    const [activeTCDataSetName, setActiveTCDataSetName] = useState("fooooo")
    const [activeTCData, setActiveTCData] = useState(null)

    useEffect(() => {
      if (dataIsValid(tcData)) {
        setActiveTCDataSet(tcData[0])
      }
    }, [tcData, setActiveTCDataSet])

    useEffect(() => {
      if(dataIsValid(activeTCDataSet)) {
        setActiveTCDataSetName(activeTCDataSet.setName)
        setActiveTCData(activeTCDataSet.data)
      }
    }, [activeTCDataSet, setActiveTCDataSetName, setActiveTCData])
    
  
    return (
      <tcDataContext.Provider value={{tcData, setTCData, activeTCDataSet, setActiveTCDataSet, activeTCDataSetName, setActiveTCDataSetName, activeTCData, setActiveTCData, tcDataLoading, setTCDataLoading, tcDataError, setTCDataError}}>
        {children}
      </tcDataContext.Provider>
    )
  }
  
export const useTCData = () => {
  const { setActiveTCDataSet, activeTCDataSetName, activeTCData, tcData, setTCData, tcDataLoading, setTCDataLoading, tcDataError, setTCDataError } = useContext(tcDataContext)
return { setActiveTCDataSet, activeTCDataSetName, activeTCData, tcData, setTCData, tcDataLoading, setTCDataLoading, tcDataError, setTCDataError }
}